export default {"src":"/_next/static/media/TJExportButtonRed.c5bcf759.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};